export default class GetSolutionMinorVersionRecordError extends Error {
}
